import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);
// eslint-disable-next-line no-unused-vars
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next("/");
};
// eslint-disable-next-line no-unused-vars
const ifAuthenticated = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next({ name: "Entrar", params: { next: to.path } });
};

const ifAdmin = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"] && store.getters["auth/isAdmin"]) {
    next();
    return;
  }
  next({ name: "Entrar - Admin", params: { next: to.path } });
};

const ifStaff = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"] && store.getters["auth/isStaff"]) {
    next();
    return;
  }
  next({ name: "Entrar - Admin", params: { next: to.path } });
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Main.vue"),
    beforeEnter: (to, from, next) => {
      if (to.path === "/" && store.getters["auth/isStaff"])
        next({ name: "Painel administrativo" });
      next();
    },
  },
  {
    path: "/cursos",
    name: "Cursos",
    component: () => import("@/views/CourseList.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/entrar",
    name: "Entrar",
    props: true,
    component: () => import("@/views/Login.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/recuperar-senha",
    name: "Recuperar senha",
    props: true,
    component: () => import("@/views/SendResetPassword.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/cadastrar-nova-senha",
    name: "Cadastrar nova senha",
    props: true,
    component: () => import("@/views/SetNewPassword.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/entrar-admin",
    name: "Entrar - Admin",
    props: true,
    component: () => import("@/views/AdminLogin.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/admin",
    name: "Painel administrativo",
    props: true,
    component: () => import("@/views/AdminMain.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/usuarios-admin",
    name: "Usuarios administrativos",
    props: true,
    component: () => import("@/views/ListAdminUsers.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/nova-conta",
    name: "Nova conta",
    props: true,
    component: () => import("@/views/NewAccount.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/atualizar-conta",
    name: "Atualizar conta",
    component: () => import("@/views/UpdateAccount.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/atualizar-conta/:id",
    name: "Ver conta",
    component: () => import("@/views/UpdateAccount.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/alterar-login",
    name: "Alterar Senha",
    component: () => import("@/views/UpdateLogin.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/alterar-senha",
    name: "Alterar Senha ",
    component: () => import("@/views/UpdateAccountAdmin.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/",
    name: "Processos Seletivos",
    component: () => import("@/views/ListPs.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/usuarios/",
    name: "Usuarios",
    component: () => import("@/views/ListUsers.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/novo/",
    name: "Novo processo seletivo",
    component: () => import("@/views/EditPS/GeneralData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/dados-gerais/:id",
    name: "Editar Processo Seletivo",
    component: () => import("@/views/EditPS/GeneralData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/membros/:id",
    name: "Editar membros do Processo Seletivo",
    component: () => import("@/views/EditPS/MembersData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/cursos/:id",
    name: "Editar cursos do Processo Seletivo",
    component: () => import("@/views/EditPS/CoursesData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/inscricao/:id",
    name: "Editar inscrição do Processo Seletivo",
    component: () => import("@/views/EditPS/InscriptionForm.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/avaliacao/:id",
    name: "Editar avaliação do Processo Seletivo",
    component: () => import("@/views/EditPS/AvaliationForm.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/cronograma/:id",
    name: "Editar cronograma do Processo Seletivo",
    component: () => import("@/views/EditPS/ScheduleData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/editar/arquivos/:id",
    name: "Editar arquivos do Processo Seletivo",
    component: () => import("@/views/EditPS/FilesData.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/:id",
    name: "Detalhes do Processo",
    component: () => import("@/views/DetailPs.vue"),
    //beforeEnter: ifAuthenticated,
  },
  {
    path: "/processos/:id/inscricao/",
    name: "Inscrição",
    component: () => import("@/views/Inscription.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    // path: '/processos/:id/inscricao/:inscription_id',
    path: "/processos/:id/minha-inscricao/",
    name: "Detalhe da inscrição",
    component: () => import("@/views/InscriptionDetail.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/processos/:id/inscricao-detalhes/:inscription_id",
    name: "Detalhe da inscrição - Leitura - COPS",
    component: () => import("@/views/InscriptionDetailView.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscricao-cops/:inscription_id",
    name: "Detalhe da inscrição - COPS",
    component: () => import("@/views/InscriptionDetailCops.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscricao-cops2/:inscription_id",
    name: "Detalhes da inscrição - COPS",
    component: () => import("@/views/InscriptionDetailCops2.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscricao/banca/:inscription_id",
    name: "Detalhe da inscrição - BANCA",
    props: true,
    component: () => import("@/views/InscriptionDetailBoardmember.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/recursos/",
    name: "Recursos",
    component: () => import("@/views/Appeals.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/processos/:id/recursos-cops/",
    name: "Recursos - COPS",
    component: () => import("@/views/AppealsCops.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/recursos/novo/",
    name: "Novo recurso",
    component: () => import("@/views/NewAppeal.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    // path: '/processos/:id/recursos/detalhes/:appeal_id',
    path: "/processos/:id/recursos/detalhes/",
    name: "Detalhes do recurso",
    component: () => import("@/views/DetailAppeal.vue"),
    beforeEnter: ifAuthenticated,
    props: true,
  },
  {
    path: "/processos/:id/recursos/detalhes/:appeal_id/cops",
    name: "Detalhes de recurso - COPS",
    component: () => import("@/views/AppealDetailCops.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscritos/",
    name: "Lista de Inscritos",
    component: () => import("@/views/InscriptionList.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscritos-listar/",
    name: "Lista de Inscritos - COPS",
    component: () => import("@/views/InscriptionListView.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscritos-avaliar/",
    name: "Inscritos - Avaliação",
    component: () => import("@/views/InscriptionsAvaliateItem.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscritos-homologar/",
    name: "Inscritos - Homologar",
    component: () => import("@/views/InscriptionListHomologated.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/resultados-enem",
    name: "Resultados ENEM",
    component: () => import("@/views/ResultsEnem.vue"),
    beforeEnter: ifAdmin,
  },
  {
    path: "/processos/:id/inscritos-avaliar/:inscription_id",
    name: "Avaliar inscrito",
    component: () => import("@/views/InscriptionAvaliation.vue"),
    beforeEnter: ifStaff,
    props: true,
  },
  {
    path: "/processos/:id/inscritos-cops/",
    name: "Lista de Inscritos - COPS",
    component: () => import("@/views/InscriptionListCops.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/processos/:id/inscritos-cops-filtros/",
    name: "Inscritos - COPS",
    component: () => import("@/views/InscriptionListCopsFilters.vue"),
    beforeEnter: ifStaff,
  },
  {
    path: "/boleto/",
    name: "Boleto",
    component: () => import("@/views/Boleto.vue"),
    beforeEnter: ifAuthenticated,
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
